<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
    <main class="container py-4">

        <!-- Page Header -->
        <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
                <h4 class="fw-bold mb-0">Countries</h4>
                <div class="text-muted small">Manage supported trading jurisdictions</div>
            </div>
        </div>

        <div class="row g-4">
            <!-- LEFT: Add Country -->
            <div class="col-12 col-lg-4">

                <div class="card shadow-sm border-0">
                    <div class="card-body">

                        <h6 class="fw-semibold mb-3">Add Country</h6>

                        <form [formGroup]="countryForm" (ngSubmit)="addCountry()">

                            <!-- Country Name -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Country Name</label>
                                <input type="text" class="form-control" formControlName="name"
                                    placeholder="e.g. Nigeria" [ngClass]="{
                       'is-invalid': name?.invalid && (name?.dirty || name?.touched)
                     }">

                                <div *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="invalid-feedback">
                                    <div *ngIf="name?.errors?.['required']">
                                        Country name is required
                                    </div>
                                </div>
                            </div>

                            <!-- ISO Code -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">ISO Code</label>
                                <input type="text" maxlength="2" class="form-control text-uppercase"
                                    formControlName="code" placeholder="NG" [ngClass]="{
                       'is-invalid': code?.invalid && (code?.dirty || code?.touched)
                     }">

                                <div *ngIf="code?.invalid && (code?.dirty || code?.touched)" class="invalid-feedback">
                                    <div *ngIf="code?.errors?.['required']">
                                        ISO code is required
                                    </div>
                                    <div *ngIf="code?.errors?.['maxlength']">
                                        ISO code must be 2 characters
                                    </div>
                                </div>
                            </div>


                            <!-- Dial Code -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">International Dial Code</label>
                                <input type="text" maxlength="8" class="form-control" formControlName="dialCode"
                                    placeholder="+234" [ngClass]="{
                       'is-invalid': dialCode?.invalid && (dialCode?.dirty || dialCode?.touched)
                     }">
                                <div *ngIf="dialCode?.invalid && (dialCode?.dirty || dialCode?.touched)"
                                    class="invalid-feedback">
                                    Enter a valid dial code, for example +234.
                                </div>
                            </div>

                            <div class="row g-2 mb-3">
                                <div class="col-6">
                                    <label class="form-label small text-muted">Minimum Phone Digits</label>
                                    <input type="number" min="4" max="15" class="form-control"
                                        formControlName="phoneNumberMinLength">
                                </div>
                                <div class="col-6">
                                    <label class="form-label small text-muted">Maximum Phone Digits</label>
                                    <input type="number" min="4" max="15" class="form-control"
                                        formControlName="phoneNumberMaxLength">
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="form-label small text-muted">Phone Display Format</label>
                                <input type="text" class="form-control" formControlName="phoneNumberFormat"
                                    placeholder="3,3,4" [ngClass]="{
                       'is-invalid': phoneNumberFormat?.invalid && (phoneNumberFormat?.dirty || phoneNumberFormat?.touched)
                     }">
                                <div class="form-text">Comma-separated digit groups. Example: 3,3,4.</div>
                                <div *ngIf="phoneNumberFormat?.invalid && (phoneNumberFormat?.dirty || phoneNumberFormat?.touched)"
                                    class="invalid-feedback">
                                    Enter a valid comma-separated format.
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="form-label small text-muted">Phone Placeholder</label>
                                <input type="text" class="form-control" formControlName="phoneNumberPlaceholder"
                                    placeholder="803 123 4567" [ngClass]="{
                       'is-invalid': phoneNumberPlaceholder?.invalid && (phoneNumberPlaceholder?.dirty || phoneNumberPlaceholder?.touched)
                     }">
                                <div *ngIf="phoneNumberPlaceholder?.invalid && (phoneNumberPlaceholder?.dirty || phoneNumberPlaceholder?.touched)"
                                    class="invalid-feedback">
                                    Phone placeholder is required.
                                </div>
                            </div>

                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" id="removeNationalPrefixZero"
                                    formControlName="removeNationalPrefixZero">
                                <label class="form-check-label small" for="removeNationalPrefixZero">
                                    Remove national leading zero before adding the dial code
                                </label>
                            </div>

        
                    <!-- Withdraw Percentage Code -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Withdrawal Fee Percentage</label>
                                <input type="number" step="0.01" class="form-control text-uppercase"
                                    formControlName="withdrawalFeePercentage" placeholder="0.00" [ngClass]="{
                       'is-invalid': withdrawalFeePercentage?.invalid && (withdrawalFeePercentage?.dirty || withdrawalFeePercentage?.touched)
                     }">

                                <div *ngIf="withdrawalFeePercentage?.invalid && (withdrawalFeePercentage?.dirty || withdrawalFeePercentage?.touched)"
                                    class="invalid-feedback">
                                    <div *ngIf="withdrawalFeePercentage?.errors?.['required']">
                                        Withdrawal fee percentage is required
                                    </div>
                                    <div *ngIf="withdrawalFeePercentage?.errors?.['min']">
                                        Withdrawal fee percentage must be at least 0
                                    </div>
                                </div>
                            </div>

                            <!-- Deposit Percentage -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Deposit Fee Percentage</label>
                                <input type="number" step="0.01" class="form-control text-uppercase"
                                    formControlName="depositFeePercentage" placeholder="0.00" [ngClass]="{
                       'is-invalid': depositFeePercentage?.invalid && (depositFeePercentage?.dirty || depositFeePercentage?.touched)
                     }">

                                <div *ngIf="depositFeePercentage?.invalid && (depositFeePercentage?.dirty || depositFeePercentage?.touched)"
                                    class="invalid-feedback">
                                    <div *ngIf="depositFeePercentage?.errors?.['required']">
                                        Deposit fee percentage is required
                                    </div>
                                    <div *ngIf="depositFeePercentage?.errors?.['min']">
                                        Deposit fee percentage must be at least 0
                                    </div>
                                </div>
                            </div>

                            <!-- Submit -->
                            <button type="submit" class="btn btn-primary w-100"
                                [disabled]="countryForm.invalid || loading">
                                <span *ngIf="!loading">Add Country</span>
                                <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
                            </button>

                        </form>
                    </div>
                </div>

            </div>

            <!-- RIGHT: Countries List -->
            <div class="col-12 col-lg-8">

                <div class="card shadow-sm border-0">
                    <div class="card-body">

                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="fw-semibold mb-0">All Countries</h6>
                            <span class="badge text-bg-secondary">
                                {{ meta?.totalRows | number : '1.0-0' }}
                            </span>
                        </div>

                        <div class="table-responsive">

                            <table class="table table-hover align-middle">

                                <thead class="table-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                        <th>Dial Code</th>
                                        <th>Status</th>
                                        <th class="text-end">Actions</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr *ngFor="let country of countries">
                                        <td class="fw-semibold">
                                            <span class="me-2">{{ countryFlag(country.code) }}</span>{{ country.name }}
                                        </td>
                                        <td>{{ country.code }}</td>
                                        <td>{{ country.dialCode || '—' }}</td>

                                        <td>
                                            <span [class]="getStatusClass(country.status)">
                                                {{ country.status }}
                                            </span>
                                        </td>

                                        <td class="text-end">
                                            <button type="button" class="btn btn-sm btn-outline-secondary me-2"
                                                (click)="openCountryModal(country)">
                                                View
                                            </button>
                                            <button class="btn btn-sm btn-outline-primary me-2"
                                                (click)="editCountry(country)">
                                                Edit
                                            </button>
                                            <button class="btn btn-sm btn-outline-danger"
                                                [disabled]="deletingId === country.id"
                                                (click)="deleteCountry(country.id)">
                                                Delete
                                            </button>

                                        </td>
                                    </tr>

                                    <tr *ngIf="!countries || countries.length === 0">
                                        <td colspan="5" class="text-center text-muted py-4">
                                            No countries added yet
                                        </td>
                                    </tr>

                                </tbody>

                            </table>
                            <app-pagination *ngIf="meta && meta.totalRows > 0" [url]='url' [counts]='meta!' (refresh)="listCountries($event)"></app-pagination>

                        </div>

                    </div>
                </div>

            </div>

        </div>


        <app-footer></app-footer>
    </main>
</div>


<!-- EDIT MODAL -->
<div class="modal fade" id="editCountryModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow">

            <div class="modal-header" style="background:#0b1f3a;">
                <h6 class="modal-title text-white fw-semibold">Edit Country</h6>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="closeEditModal()"></button>
            </div>

            <form [formGroup]="editCountryForm" (ngSubmit)="saveCountryEdits()">

                <div class="modal-body">

                    <!-- Hidden id -->
                    <input type="hidden" formControlName="id">

                    <div class="mb-3">
                        <label class="form-label small text-muted">Country Name</label>
                        <input type="text" class="form-control" formControlName="name"
                            [ngClass]="{ 'is-invalid': editName?.invalid && (editName?.dirty || editName?.touched) }" />

                        <div *ngIf="editName?.invalid && (editName?.dirty || editName?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editName?.errors?.['required']">Country name is required</div>
                        </div>
                    </div>


                    <div class="mb-3">
                        <label class="form-label small text-muted">International Dial Code</label>
                        <input type="text" maxlength="8" class="form-control" formControlName="dialCode"
                            placeholder="+234"
                            [ngClass]="{ 'is-invalid': editDialCode?.invalid && (editDialCode?.dirty || editDialCode?.touched) }">
                        <div *ngIf="editDialCode?.invalid && (editDialCode?.dirty || editDialCode?.touched)"
                            class="invalid-feedback">
                            Enter a valid dial code, for example +234.
                        </div>
                    </div>

                    <div class="row g-2 mb-3">
                        <div class="col-6">
                            <label class="form-label small text-muted">Minimum Phone Digits</label>
                            <input type="number" min="4" max="15" class="form-control"
                                formControlName="phoneNumberMinLength">
                        </div>
                        <div class="col-6">
                            <label class="form-label small text-muted">Maximum Phone Digits</label>
                            <input type="number" min="4" max="15" class="form-control"
                                formControlName="phoneNumberMaxLength">
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label small text-muted">Phone Display Format</label>
                        <input type="text" class="form-control" formControlName="phoneNumberFormat"
                            placeholder="3,3,4"
                            [ngClass]="{ 'is-invalid': editPhoneNumberFormat?.invalid && (editPhoneNumberFormat?.dirty || editPhoneNumberFormat?.touched) }">
                        <div class="form-text">Comma-separated digit groups. Example: 3,3,4.</div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label small text-muted">Phone Placeholder</label>
                        <input type="text" class="form-control" formControlName="phoneNumberPlaceholder"
                            placeholder="803 123 4567"
                            [ngClass]="{ 'is-invalid': editPhoneNumberPlaceholder?.invalid && (editPhoneNumberPlaceholder?.dirty || editPhoneNumberPlaceholder?.touched) }">
                    </div>

                    <div class="form-check mb-3">
                        <input class="form-check-input" type="checkbox" id="editRemoveNationalPrefixZero"
                            formControlName="removeNationalPrefixZero">
                        <label class="form-check-label small" for="editRemoveNationalPrefixZero">
                            Remove national leading zero before adding the dial code
                        </label>
                    </div>

                    <!-- Withdraw Percentage Code -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Withdrawal Fee Percentage</label>
                        <input type="number" step="0.01" class="form-control text-uppercase"
                            formControlName="withdrawalFeePercentage" placeholder="0.00" [ngClass]="{
                       'is-invalid': editWithdrawalFeePercentage?.invalid && (editWithdrawalFeePercentage?.dirty || editWithdrawalFeePercentage?.touched)
                     }">

                        <div *ngIf="editWithdrawalFeePercentage?.invalid && (editWithdrawalFeePercentage?.dirty || editWithdrawalFeePercentage?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editWithdrawalFeePercentage?.errors?.['required']">
                                Withdrawal fee percentage is required
                            </div>
                            <div *ngIf="editWithdrawalFeePercentage?.errors?.['min']">
                                Withdrawal fee percentage must be at least 0
                            </div>
                        </div>
                    </div>

                    <!-- Deposit Percentage -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Deposit Fee Percentage</label>
                        <input type="number" step="0.01" class="form-control text-uppercase"
                            formControlName="depositFeePercentage" placeholder="0.00" [ngClass]="{
                       'is-invalid': editDepositFeePercentage?.invalid && (editDepositFeePercentage?.dirty || editDepositFeePercentage?.touched)
                     }">

                        <div *ngIf="editDepositFeePercentage?.invalid && (editDepositFeePercentage?.dirty || editDepositFeePercentage?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editDepositFeePercentage?.errors?.['required']">
                                Deposit fee percentage is required
                            </div>
                            <div *ngIf="editDepositFeePercentage?.errors?.['min']">
                                Deposit fee percentage must be at least 0
                            </div>
                        </div>
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" (click)="closeEditModal()">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary" [disabled]="editCountryForm.invalid || loadingEdit">
                        <span *ngIf="!loadingEdit">Save Changes</span>
                        <span *ngIf="loadingEdit" class="spinner-border spinner-border-sm"></span>
                    </button>
                </div>

            </form>

        </div>
    </div>
</div>
<!-- COUNTRY DETAILS MODAL -->
<div class="modal fade" id="countryDetailsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content border-0 shadow">

            <div class="modal-header" style="background:#0b1f3a;">
                <div>
                    <h6 class="modal-title text-white fw-semibold mb-0">Country</h6>
                    <div class="text-white-50 small">
                        {{ selectedCountry?.name }} • {{ selectedCountry?.code }}
                    </div>
                </div>

                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="closeCountryModal()"></button>
            </div>

            <div class="modal-body">

                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <button id="countryDetailsTabButton" class="nav-link active" data-bs-toggle="tab"
                            data-bs-target="#countryTabDetails" type="button">
                            Details
                        </button>
                    </li>

                    <li class="nav-item">
                        <button id="currencyTabButton" class="nav-link" data-bs-toggle="tab"
                            data-bs-target="#currencyTabOrders" type="button">
                            Currency
                            <span class="badge text-bg-secondary ms-1">{{ selectedCurrencyCountry.length || 0 }}</span>
                        </button>
                    </li>

                    <li class="nav-item" *ngIf="showCurrencyAssignmentTab">
                        <button id="currencyAssignmentTabButton" class="nav-link" data-bs-toggle="tab"
                            data-bs-target="#currencyAssignmentTab" type="button">
                            {{ currencyAssignmentLabel }}
                        </button>
                    </li>
                </ul>

                <div class="tab-content pt-3" *ngIf="selectedCountry as country">

                    <!-- DETAILS -->
                    <div class="tab-pane fade show active" id="countryTabDetails">

                        <div class="p-3 rounded-3 border bg-body">
                            <div class="d-flex justify-content-between mb-2">
                                <div class="fw-semibold">Overview</div>
                                <span class="badge" [ngClass]="getStatusClass(country.status)">
                                    {{ country.status }}
                                </span>
                            </div>

                            <div class="row g-3 small">
                                <div class="col-6">
                                    <div class="text-muted">Name</div>
                                    <div class="fw-semibold">{{ country.name }}</div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted">Code</div>
                                    <div class="fw-semibold text-uppercase">
                                        {{ countryFlag(country.code) }} {{ country.code }}
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted">Dial Code</div>
                                    <div class="fw-semibold">{{ country.dialCode || '—' }}</div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted">National Phone Digits</div>
                                    <div class="fw-semibold">
                                        {{ country.phoneNumberMinLength ?? '—' }}–{{ country.phoneNumberMaxLength ?? '—' }}
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted">Phone Display Format</div>
                                    <div class="fw-semibold">{{ country.phoneNumberFormat || '—' }}</div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted">Phone Placeholder</div>
                                    <div class="fw-semibold">{{ country.phoneNumberPlaceholder || '—' }}</div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted">Remove Leading Zero</div>
                                    <div class="fw-semibold">{{ country.removeNationalPrefixZero ? 'Yes' : 'No' }}</div>
                                </div>

                                <div class="col-6">
                                    <div class="text-muted">Deposit Fee Percentage</div>
                                    <div class="fw-semibold">{{ country.depositFeePercentage | number}}</div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted">Deposit Fee Percentage</div>
                                    <div class="fw-semibold text-uppercase">{{ country.withdrawalFeePercentage
                                        | number}}</div>
                                </div>

                                <div class="col-6">
                                    <div class="text-muted">Created</div>
                                    <div class="fw-semibold">{{ country.createdAt | date:'medium' }}</div>
                                </div>
                                <div class="col-6">
                                    <div class="text-muted">Last Updated</div>
                                    <div class="fw-semibold">{{ country.lastUpdatedAt | date:'medium' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- CURRENCIES (optional) -->
                    <div class="tab-pane fade" id="currencyTabOrders">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div class="fw-semibold">Assigned Currencies</div>
                            <button type="button" class="btn btn-sm btn-primary"
                                (click)="openCurrencyAssignmentTab()">
                                {{ currencyAssignmentLabel }}
                            </button>
                        </div>

                        <div class="table-responsive">
                            <div *ngIf="loadingCountryCurrencies" class="currency-modal-state text-muted mb-3">
                                <span class="spinner-border spinner-border-sm me-2"></span>
                                Loading currencies...
                            </div>

                            <table class="table table-hover align-middle">
                                <thead class="table-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                        <th>Symbol</th>
                                        <th class="text-end">Min Order</th>
                                        <th class="text-end">Max Order</th>
                                        <th>Status</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let o of selectedCurrencyCountry">
                                        <td class="fw-semibold">{{ o.currency.name }}</td>
                                        <td>{{ o.currency.code }}</td>
                                        <td>{{ o.currency.symbol }}</td>
                                        <td class="text-end">{{ o.currency.minOrder | smartAmount }}</td>
                                        <td class="text-end">{{ o.currency.maxOrder | smartAmount }}</td>
                                        <td><span [class]="getStatusClass(o.status)">{{ o.status }}</span></td>
                                        <td><button (click)="deleteCountryCurrency(o)" class="btn btn-danger btn-sm">Delete</button></td>
                                    </tr>

                                    <tr *ngIf="!loadingCountryCurrencies && (!selectedCurrencyCountry || selectedCurrencyCountry.length === 0)">
                                        <td colspan="7" class="text-center text-muted py-4">No currency</td>
                                    </tr>
                                </tbody>
                            </table>
                            <app-pagination *ngIf="metaCurrencyCountry && metaCurrencyCountry.totalRows > 0" [url]='url' [counts]='metaCurrencyCountry!' (refresh)="getCurrencyCountry($event)"></app-pagination>
                        </div>
                    </div>

                    <!-- CURRENCY ASSIGNMENT -->
                    <div class="tab-pane fade" id="currencyAssignmentTab">
                        <form [formGroup]="currencyAssignmentForm" (ngSubmit)="assignCurrencyToCountry()"
                            class="currency-assignment-panel">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <div class="fw-semibold">{{ currencyAssignmentLabel }}</div>
                                    <div class="text-muted small">{{ country.name }} • {{ country.code }}</div>
                                </div>
                                <button type="button" class="btn btn-sm btn-outline-secondary"
                                    (click)="returnToCurrencyTab()">
                                    Back
                                </button>
                            </div>

                            <label class="form-label small text-muted" for="countryCurrencyCode">
                                Currency
                            </label>

                            <select id="countryCurrencyCode" class="form-select" formControlName="currencyCode"
                                [ngClass]="{
                                    'is-invalid': assignmentCurrencyCode?.invalid &&
                                        (assignmentCurrencyCode?.dirty || assignmentCurrencyCode?.touched)
                                }">
                                <option value="">Select a currency</option>
                                <option *ngFor="let currency of assignmentCurrencies"
                                    [value]="currency.currencyCode"
                                    [disabled]="isCurrencyAssigned(currency.currencyCode)">
                                    {{ currency.currencyCode }} - {{ currency.currencyName }}
                                    {{ isCurrencyAssigned(currency.currencyCode) ? '(already added)' : '' }}
                                </option>
                            </select>

                            <div class="invalid-feedback">
                                Select a currency to add.
                            </div>

                            <div *ngIf="loadingCurrencyAssignment" class="currency-modal-state text-muted">
                                <span class="spinner-border spinner-border-sm me-2"></span>
                                Loading currencies...
                            </div>

                            <div *ngIf="!loadingCurrencyAssignment && assignmentCurrencies.length === 0"
                                class="currency-modal-state text-muted">
                                No currencies are available.
                            </div>

                            <div class="d-flex justify-content-end mt-4">
                                <button type="submit" class="btn btn-primary"
                                    [disabled]="currencyAssignmentForm.invalid || loadingCurrencyAssignment || savingCurrencyAssignment || assignmentCurrencies.length === 0">
                                    <span *ngIf="!savingCurrencyAssignment">{{ currencyAssignmentLabel }}</span>
                                    <span *ngIf="savingCurrencyAssignment" class="spinner-border spinner-border-sm"></span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="closeCountryModal()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
